/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AlertLog} from '../models/AlertLog';
import type {Error} from '../models/Error';
import type {PlatformAlert} from '../models/PlatformAlert';
import type {UpdatePlatformAlertRequest} from '../models/UpdatePlatformAlertRequest';

export interface CreatePlatformAlert$Request {
    updatePlatformAlertRequest: UpdatePlatformAlertRequest;
    reason?: string;
}

export interface CreatePlatformAlert$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createPlatformAlertRequest = createAction<PayloadData<void, CreatePlatformAlert$Request>>('PLATFORM_ALERTS__CREATE_PLATFORM_ALERT__REQUEST');
export const createPlatformAlertSuccess = createAction<PayloadData<void, CreatePlatformAlert$Request>>('PLATFORM_ALERTS__CREATE_PLATFORM_ALERT__SUCCESS');
export const createPlatformAlertFailure = createAction<PayloadData<Error, CreatePlatformAlert$Request, true>>('PLATFORM_ALERTS__CREATE_PLATFORM_ALERT__FAILURE');

export const createPlatformAlertActions = [
    createPlatformAlertRequest,
    createPlatformAlertSuccess,
    createPlatformAlertFailure
] as const;

/**
 * @param {UpdatePlatformAlertRequest} meta.updatePlatformAlertRequest
 * @param {string} [meta.reason]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createPlatformAlert = (meta: CreatePlatformAlert$Request, config?: CreatePlatformAlert$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: createPlatformAlertActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/platform-alert-builder/alerts`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updatePlatformAlertRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetActivePlatformAlerts$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getActivePlatformAlertsRequest = createAction<PayloadData<void>>('PLATFORM_ALERTS__GET_ACTIVE_PLATFORM_ALERTS__REQUEST');
export const getActivePlatformAlertsSuccess = createAction<PayloadData<Array<PlatformAlert>>>('PLATFORM_ALERTS__GET_ACTIVE_PLATFORM_ALERTS__SUCCESS');
export const getActivePlatformAlertsFailure = createAction<PayloadData<Error, void, true>>('PLATFORM_ALERTS__GET_ACTIVE_PLATFORM_ALERTS__FAILURE');

export const getActivePlatformAlertsActions = [
    getActivePlatformAlertsRequest,
    getActivePlatformAlertsSuccess,
    getActivePlatformAlertsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getActivePlatformAlerts = (config?: GetActivePlatformAlerts$Config) => {
    return {
        CALL_API: {
            types: getActivePlatformAlertsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/platform-alert-builder/alerts`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetAlertAuditLogs$Request {
    alertId: number;
}

export interface GetAlertAuditLogs$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAlertAuditLogsRequest = createAction<PayloadData<void, GetAlertAuditLogs$Request>>('PLATFORM_ALERTS__GET_ALERT_AUDIT_LOGS__REQUEST');
export const getAlertAuditLogsSuccess = createAction<PayloadData<Array<AlertLog>, GetAlertAuditLogs$Request>>('PLATFORM_ALERTS__GET_ALERT_AUDIT_LOGS__SUCCESS');
export const getAlertAuditLogsFailure = createAction<PayloadData<Error, GetAlertAuditLogs$Request, true>>('PLATFORM_ALERTS__GET_ALERT_AUDIT_LOGS__FAILURE');

export const getAlertAuditLogsActions = [
    getAlertAuditLogsRequest,
    getAlertAuditLogsSuccess,
    getAlertAuditLogsFailure
] as const;

/**
 * @param {number} meta.alertId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAlertAuditLogs = (meta: GetAlertAuditLogs$Request, config?: GetAlertAuditLogs$Config) => {
    return {
        CALL_API: {
            types: getAlertAuditLogsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/platform-alert-builder/alerts/${meta.alertId}/logs`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetPlatformAlertById$Request {
    alertId: number;
}

export interface GetPlatformAlertById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getPlatformAlertByIdRequest = createAction<PayloadData<void, GetPlatformAlertById$Request>>('PLATFORM_ALERTS__GET_PLATFORM_ALERT_BY_ID__REQUEST');
export const getPlatformAlertByIdSuccess = createAction<PayloadData<PlatformAlert, GetPlatformAlertById$Request>>('PLATFORM_ALERTS__GET_PLATFORM_ALERT_BY_ID__SUCCESS');
export const getPlatformAlertByIdFailure = createAction<PayloadData<Error, GetPlatformAlertById$Request, true>>('PLATFORM_ALERTS__GET_PLATFORM_ALERT_BY_ID__FAILURE');

export const getPlatformAlertByIdActions = [
    getPlatformAlertByIdRequest,
    getPlatformAlertByIdSuccess,
    getPlatformAlertByIdFailure
] as const;

/**
 * @param {number} meta.alertId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getPlatformAlertById = (meta: GetPlatformAlertById$Request, config?: GetPlatformAlertById$Config) => {
    return {
        CALL_API: {
            types: getPlatformAlertByIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/platform-alert-builder/alerts/${meta.alertId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface HidePlatformAlert$Request {
    alertId: number;
    reason?: string;
}

export interface HidePlatformAlert$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const hidePlatformAlertRequest = createAction<PayloadData<void, HidePlatformAlert$Request>>('PLATFORM_ALERTS__HIDE_PLATFORM_ALERT__REQUEST');
export const hidePlatformAlertSuccess = createAction<PayloadData<void, HidePlatformAlert$Request>>('PLATFORM_ALERTS__HIDE_PLATFORM_ALERT__SUCCESS');
export const hidePlatformAlertFailure = createAction<PayloadData<Error, HidePlatformAlert$Request, true>>('PLATFORM_ALERTS__HIDE_PLATFORM_ALERT__FAILURE');

export const hidePlatformAlertActions = [
    hidePlatformAlertRequest,
    hidePlatformAlertSuccess,
    hidePlatformAlertFailure
] as const;

/**
 * @param {number} meta.alertId
 * @param {string} [meta.reason]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const hidePlatformAlert = (meta: HidePlatformAlert$Request, config?: HidePlatformAlert$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: hidePlatformAlertActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/platform-alert-builder/alerts/${meta.alertId}`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdatePlatformAlert$Request {
    alertId: number;
    updatePlatformAlertRequest: UpdatePlatformAlertRequest;
    reason?: string;
}

export interface UpdatePlatformAlert$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updatePlatformAlertRequest = createAction<PayloadData<void, UpdatePlatformAlert$Request>>('PLATFORM_ALERTS__UPDATE_PLATFORM_ALERT__REQUEST');
export const updatePlatformAlertSuccess = createAction<PayloadData<void, UpdatePlatformAlert$Request>>('PLATFORM_ALERTS__UPDATE_PLATFORM_ALERT__SUCCESS');
export const updatePlatformAlertFailure = createAction<PayloadData<Error, UpdatePlatformAlert$Request, true>>('PLATFORM_ALERTS__UPDATE_PLATFORM_ALERT__FAILURE');

export const updatePlatformAlertActions = [
    updatePlatformAlertRequest,
    updatePlatformAlertSuccess,
    updatePlatformAlertFailure
] as const;

/**
 * @param {number} meta.alertId
 * @param {UpdatePlatformAlertRequest} meta.updatePlatformAlertRequest
 * @param {string} [meta.reason]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updatePlatformAlert = (meta: UpdatePlatformAlert$Request, config?: UpdatePlatformAlert$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: updatePlatformAlertActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/platform-alert-builder/alerts/${meta.alertId}`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updatePlatformAlertRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

